import { render, staticRenderFns } from "./InstitutionUserRow.vue?vue&type=template&id=0fd70ef2"
import script from "./InstitutionUserRow.vue?vue&type=script&lang=js"
export * from "./InstitutionUserRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports